/* eslint-disable */
import { TextField, Tooltip } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { compose } from 'recompose';
import { fromEvent } from 'rxjs';
import { catchError, debounceTime, filter, retry, switchMap, tap } from 'rxjs/operators';
import withServices from '../../Contexts/Services/WithServices.context';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import searchDocketsStyles from './DocketsList.component.styles';

/**
 * SearchDockets
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const SearchDockets = ({ account, classes, dateTo, dateFrom, onResults, order, onError, onStartSearch, services, sort, total }) => {
  const searchRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [currentKeyword, setCurrentKeyword] = useState(``);
  let keyDownSubscriber = null;

  useEffect(() => {
    if (keyDownSubscriber) {
      keyDownSubscriber.unsubscribe();
    }
    const fromKeyDown$ = fromEvent(searchRef.current, `keydown`).pipe(
      debounceTime(300),
      filter((el) => el.target.value.length > 2 || el.target.value === ``),
      tap((el) => {
        setIsLoading(true);
        onStartSearch(el.target.value);
        setCurrentKeyword(el.target.value);
      }),
      switchMap((el) => {
        const withKeyword = { account, dateFrom, dateTo, keyword: el.target.value, order, sort, total };
        return services.orderService.getDockets(withKeyword).pipe(
          retry(1),
          catchError((err) => {
            setIsLoading(false);
            onError();
          }),
        );
      }),
    );

    keyDownSubscriber = fromKeyDown$.subscribe((result) => {
      setIsLoading(false);
      onResults(result);
    });

    return () => {
      keyDownSubscriber.unsubscribe();
    };
  }, [account, dateFrom, dateTo, order, sort]);

  return (
    <React.Fragment>
      <TextField
        className={classes.searchTextField}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {!isLoading ? (
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title="Search by Product, Project Name, Street, Suburb, Docket # and Purchase Order #"
                  placement="right-end"
                >
                  <SearchIcon />
                </Tooltip>
              ) : (
                <CircularProgress className={classes.searchSpinner} />
              )}
            </InputAdornment>
          ),
          classes: { focused: classes.searchTextFieldFocused },
        }}
        onClick={(el) => {
          searchRef.current.focus();
        }}
        inputRef={searchRef}
        onChange={(e) => setCurrentKeyword(e.target.value)}
        placeholder="Search"
        value={currentKeyword}
      />
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
SearchDockets.propTypes = {
  account: PropTypes.string.isRequired,
  classes: ThemeStatePropTypes.classes.isRequired,
  dateFrom: PropTypes.object.isRequired,
  dateTo: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
  onResults: PropTypes.func.isRequired,
  onStartSearch: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  services: PropTypes.object.isRequired,
  sort: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
};

export default compose(
  withServices,
  withStyles(themeCreateInjectableStyles(searchDocketsStyles), { withTheme: true }),
)(SearchDockets);
